import React from 'react';
import {
  List,
  Datagrid,
  DateField,
  ReferenceField,
  TextField,
  ShowButton,
  CardActions,
  CreateButton,
  FunctionField,
  Filter,
  ReferenceInput,
  SelectInput,
  NumberField,
  EditButton,
} from 'react-admin';
import FullNameField from '../General/FullNameField';
import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';
import { offeringCategory } from '../../helpers/mappings';

const statusChoices = [
  { id: 'drafted', name: 'Drafted' },
  { id: 'created', name: 'Created' },
  { id: 'sent', name: 'Sent' },
  { id: 'deleted', name: 'Deleted' },
];

const ConditionalOfferField = (({ classes, ...props }) => (
  <FunctionField
    {...props}
    render={record => record.offer && `${Object.values(offeringCategory).find(c => c.value === record.offer.category).label}`}
  />
));

const ConditionalEditButton = (({ classes, ...props }) => (
  <FunctionField
    {...props}
    render={record => !['sent', 'created'].includes(record.status) && <EditButton {...props} />}
  />
));

const OfferCampaignFilter = props => (
  <Filter {...props}>
    <ReferenceInput
      label="Offer"
      source="offerId"
      reference="offerings"
      alwaysOn
      perPage={100}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <SelectInput
      label="Status"
      source="status"
      choices={statusChoices}
      alwaysOn
    />
  </Filter>
);


const OfferOrderListActions = ({
  basePath,
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter,
}) => {
  const adminLevel = getAdminLevel();

  return (
    <CardActions>
      {filters && React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      }) }
      { adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN ?
        <CreateButton basePath={basePath} /> : undefined
      }
    </CardActions>
  );
};

export default props => (
  <List
    {...props}
    title="Offer Campaigns"
    actions={<OfferOrderListActions />}
    filters={<OfferCampaignFilter />}
    bulkActionButtons={false}
  >
    <Datagrid>
      <DateField source="createdAt" />
      <TextField label="Offer name" source="offer.name" />
      <ReferenceField label="User" source="userId" reference="users" linkType="show" sortable={false}>
        <FullNameField />
      </ReferenceField>
      <NumberField label="Campaign subject" source="mailChimpCampaign.settings.subject_line" />
      <NumberField label="Emails sent" source="mailChimpCampaign.emails_sent" />
      <NumberField label="Emails delivered" source="mailChimpCampaign.delivery_status.emails_sent" />
      <TextField source="status" />
      <ConditionalOfferField label="Offer Type" />
      <ConditionalEditButton {...props} />
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/OfferCampaign/List.js